import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-matching',
  templateUrl: './help-add-matching.component.html',
  styleUrls: ['./help-add-matching.component.scss']
})
export class HelpAddMatchingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
